let basePath = process.env.APP_BASE_PATH;

if (basePath) {
  // Ensure to have a slash at the beginning and on the end
  basePath = basePath.replace(/^\/*/, '/').replace(/\/*$/, '/');
} else {
  basePath = './';
}

module.exports = basePath;
